import React, { FC, useContext } from 'react'
import theme from '../../../../../../theme'
import { Alert } from '../../../../../../types/alert'
import { Box } from '@mui/system'
import AvatarAndName from '../../../../../../components/AvatarAndName'
import { executeResponseError, getNameOrMail } from '../../../../../../helpers'
import { ClosePopoversContext } from '../../../../../../components/ClosePopoversProvider'
import { history } from '../../../../../../store'
import { PAGE_PATIENTS_PATIENT_DASHBOARD } from '../../../../../../constants/navigation'
import api from '../../../../../../api'
import { getRealtimeAlerts } from '../../../../../../store/reducers/realtimeAlerts/actions'
import { useAlert } from 'react-alert'
import { useAppDispatch } from '../../../../../../hooks/useAppDispatch'

const alertItemSx: object = {
	p: 4,
	pl: 20,
	borderBottom: 1,
	borderColor: theme.palette.grey[200],
	position: 'relative',
	minHeight: '5rem',
	flexGrow: 1,
	flexDirection: 'column',
	cursor: 'pointer',
	'&:hover': {
		bgcolor: theme.palette.grey[200],
		transition: '0.25s',
	},
}

interface SidebarAlertProps {
	readonly alert: Alert
	readonly children?: React.ReactNode
}

const SidebarAlert: FC<SidebarAlertProps> = ({
	alert,
	children,
}: SidebarAlertProps) => {
	const onClosePopup = useContext(ClosePopoversContext)
	const alertPopup = useAlert()
	const dispatch = useAppDispatch()

	const handleClick: React.MouseEventHandler<HTMLDivElement> = async () => {
		history.push(
			PAGE_PATIENTS_PATIENT_DASHBOARD.replace(
				':id',
				alert.patientData?.ID
			)
		)

		onClosePopup()

		try {
			await api.alerts.seen(alert._id)

			await dispatch(getRealtimeAlerts())
		} catch (e) {
			const error = executeResponseError(e, 'Seen alert error')

			error && alertPopup.error(error)
		}
	}

	return (
		<Box sx={alertItemSx} onClick={handleClick}>
			<Box display={'flex'}>
				<AvatarAndName
					name={getNameOrMail(
						alert.patientData?.firstName || '',
						alert.patientData?.lastName || '',
						alert.patientData?.email
					)}
					avatarSrc={alert.patientData?.imageUrl}
				/>
			</Box>

			{children}
		</Box>
	)
}

export default SidebarAlert
